import * as React from 'react';
import {
  DialogContent,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Typography,
  CircularProgress,
  Box,
} from '@mui/material';
import { useDispatch } from 'react-redux';
import { updateSlideAxes } from '../slices/presentation';
import { CDialog, CDialogTitle, CDialogActions, CButton } from '../components/common/Modal';

export default function AxisModal({ open, pId, index, data, x_column, y_column, handleClose, onSave }) {
  const dispatch = useDispatch();
  const [loading, setLoading] = React.useState(false);

  // Derive column list from existing data
  const columns = data && data.length > 0 ? Object.keys(data[0]) : [];

  const [xColumn, setXColumn] = React.useState([]);
  const [yColumn, setYColumn] = React.useState('');

  // Sync with current values when modal opens
  React.useEffect(() => {
    if (open) {
      setXColumn(
        x_column ? (Array.isArray(x_column) ? x_column : [x_column]) : columns.slice(0, 1)
      );
      setYColumn(y_column || columns[1] || '');
    }
  }, [open]); // eslint-disable-line react-hooks/exhaustive-deps

  const handleSave = () => {
    setLoading(true);
    dispatch(updateSlideAxes({
      presentation: pId,
      index,
      x_column: xColumn,
      y_column: yColumn,
    })).then(() => {
      setLoading(false);
      if (onSave) onSave(xColumn, yColumn);
      handleClose();
    }).catch(() => setLoading(false));
  };

  return (
    <CDialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
      <CDialogTitle>Edit Chart Axes</CDialogTitle>
      <DialogContent>
        <Typography variant="body2" sx={{ mt: 1, mb: 0.5, color: 'text.secondary' }}>
          Choose which columns to use for the chart axes.
        </Typography>
        <FormControl sx={{ mt: 2 }} size="small" fullWidth>
          <InputLabel id="axis-x-label">X Axis (Categories)</InputLabel>
          <Select
            labelId="axis-x-label"
            multiple
            value={xColumn}
            label="X Axis (Categories)"
            onChange={(e) => setXColumn(e.target.value)}
            renderValue={(selected) => selected.join(', ')}
            variant="outlined"
          >
            {columns.map(col => (
              <MenuItem key={col} value={col}>{col}</MenuItem>
            ))}
          </Select>
        </FormControl>
        <FormControl sx={{ mt: 2 }} size="small" fullWidth>
          <InputLabel id="axis-y-label">Y Axis (Values)</InputLabel>
          <Select
            labelId="axis-y-label"
            value={yColumn}
            label="Y Axis (Values)"
            onChange={(e) => setYColumn(e.target.value)}
            variant="outlined"
          >
            {columns.map(col => (
              <MenuItem key={col} value={col}>{col}</MenuItem>
            ))}
          </Select>
        </FormControl>
        {loading && (
          <Box sx={{ display: 'flex', justifyContent: 'center', mt: 2 }}>
            <CircularProgress size={24} sx={{ opacity: 0.7 }} />
          </Box>
        )}
      </DialogContent>
      <CDialogActions>
        <CButton onClick={handleClose}>Cancel</CButton>
        <CButton onClick={handleSave} disabled={loading || !xColumn.length || !yColumn}>Save</CButton>
      </CDialogActions>
    </CDialog>
  );
}
